'use strict';

/**
 * @ngdoc function
 * @name exhibitorPortalApp.controller:SurveyCtrl
 * @description
 * # Survey Ctrl
 * Controller of the exhibitorPortalApp
 */

(function (angular, window, undefined) {
  var SurveyCtrl = function ($scope, $filter, $state, $q, $timeout, CurrentEvent, Surveys, Survey, Search, SurveyService, modalFactory, $stateParams, SAVE_STATUS) {
    'ngInject'
    var self = this;

    Survey.SurveyQuestions = $filter('orderBy')(Survey.SurveyQuestions, 'DisplayOrder');

    for (var i = 0; i < Survey.SurveyQuestions.length; i++)
      Survey.SurveyQuestions[i].DisplayOrder = i;

    self.baseSurvey = Survey;
    self.survey = angular.copy(Survey);
    self.search = Search.survey;
    self.search.edit = false;
    self.debounce = 30000;
    self.pendingSave = null;
    self.saveStatus = null;
    self.SAVE_STATUS = SAVE_STATUS;
    self.isEdit = $stateParams.id !== "0";

    self.isUsed = _.any(self.survey.SurveyQuestions, function (sq) { return sq.IsUsed; });

    self.existingSurveyNames = Surveys.filter(function (s) { return s.Id !== Survey.Id; })
      .map(function (s) { return s.Name; });

    const confirmUnsavedChanges = function (event) {
      var pageChangeOk = true;
      if (!angular.equals(self.survey, self.baseSurvey)) {
        if (!window.confirm('You have unsaved changes that will be lost, are you sure you want to proceed?')) {
          pageChangeOk = false;
          event.preventDefault();
        } else {
          if(self.pendingSave) {
            $timeout.cancel(self.pendingSave);
          }
        }
      }

      self.removeSurvey(pageChangeOk);
    };
    
    //PDJ 2016.10.12: Remove this survey, leaving it is causing a mess in some places do not list it when name is blank then saving goes wonky
    self.removeSurvey = function (pageChangeOk) {
      if (pageChangeOk == true && self.survey.Id == 0) {
        for (var i = 0; i < SurveyService.data.surveys[CurrentEvent.ShowCode].length; i++) {
          if (SurveyService.data.surveys[CurrentEvent.ShowCode][i].Id == self.survey.Id) {
            SurveyService.data.surveys[CurrentEvent.ShowCode].splice(i, 1);
            break;
          }
        }
      }
    }

    $scope.$on('$stateChangeStart', confirmUnsavedChanges);
    $scope.$on('beforeLeave', confirmUnsavedChanges);

    if(!window._saveOnlineAgain) {
      window._saveOnlineAgain = function (e) {
        self.autoSave(true);
      }
      window.addEventListener('online', window._saveOnlineAgain);
    }
    
    if (!window._surveyBeforeUnload) {
        window._surveyBeforeUnload = function(e) {
            var pageChangeOk = true;
            if(!angular.equals(self.survey, self.baseSurvey)) {
              pageChangeOk = false;
              e.preventDefault();
              e.returnValue = '';
            } else if(self.pendingSave) {
              $timeout.cancel(self.pendingSave);
            }

            self.removeSurvey(pageChangeOk);
        };
        window.addEventListener('beforeunload', window._surveyBeforeUnload);
    }

    $scope.$on('$destroy', function() {
        if (window._surveyBeforeUnload) {
            window.removeEventListener('beforeunload', window._surveyBeforeUnload);
            window._surveyBeforeUnload = null;
        }
        if(window._saveOnlineAgain) {
          window.removeEventListener('online', window._saveOnlineAgain);
          window._saveOnlineAgain = null;
        }
    });

    self.markQuestionInactive = function (question) {
      if (question) {
        self.deleteModalLinkedQuestions = self.survey.SurveyQuestions.filter(function (sq) {
          return _.any(sq.SurveyAnswers, function (sa) {
            return sa.BranchAction == 'OVERRIDE' && sa.NextQuestionId == question.Id
          });
        });

        if (self.deleteModalLinkedQuestions && self.deleteModalLinkedQuestions.length) {
          self.showSurveyFixerUpper = true;
        } else {
          question.IsActive = false;
        }
      }
    };

    self.autoSave = function (skipDebounce ) {
      if(!self.isEdit) return;
      if(self.pendingSave) {
        $timeout.cancel(self.pendingSave);
      }
      self.pendingSave = $timeout(function () {
          self.saveStatus = SAVE_STATUS.SAVING;
          self.save(false).then(function () {
            self.saveStatus = SAVE_STATUS.SAVED;
            $timeout(function () {
              self.saveStatus = SAVE_STATUS.FADEOUT_SAVED;
              $timeout(function () {
                self.saveStatus = null;
              }, 300);
            }, 5000);
          }).catch(function () {
            self.saveStatus = SAVE_STATUS.ERROR;
            $timeout(function () {
              self.saveStatus = SAVE_STATUS.FADEOUT_ERROR;
              $timeout(function () {
                self.saveStatus = null;
              }, 300);
            }, 5000);
          });
      }, skipDebounce ? 1 : self.debounce);
    }

    self.save = function (redirect) {
      //check to see if we actually need to save
      if (!angular.equals(self.survey, self.baseSurvey)) {
        return SurveyService
          .saveSurvey({
            params: { showCode: CurrentEvent.ShowCode },
            data: {
              showCode: CurrentEvent.ShowCode,
              survey: self.survey
            }
          })
          .then(function (survey) {
            for (var i = 0; i < SurveyService.data.surveys[CurrentEvent.ShowCode].length; i++)
              if (SurveyService.data.surveys[CurrentEvent.ShowCode][i].Id == survey.Id) {
                self.baseSurvey = SurveyService.data.surveys[CurrentEvent.ShowCode][i];
                self.survey = angular.copy(self.baseSurvey);
                break;
              }

            if (redirect !== false && self.survey.SurveyQuestions.length)
              $state.go('event.surveys.surveys');
          });
      }
      //nope, but code still expects this to return a promise so return one and resolve it immediately
      else {
        var d = $q.defer();

        $timeout(function () {
          d.resolve();

          if (redirect !== false && self.survey.SurveyQuestions.length)
            $state.go('event.surveys.surveys');
        });

        return d.promise;
      }
    };

    self.upClick = function (index) {
      if (index === 0)
        self.paginated[index].DisplayOrder = self.paginated[self.paginated.length - 1].DisplayOrder + 1;
      else {
        var dest, destDisplayOrder;

        dest = self.paginated[index - 1];
        destDisplayOrder = dest.DisplayOrder;

        dest.DisplayOrder = self.paginated[index].DisplayOrder;
        self.paginated[index].DisplayOrder = destDisplayOrder;
      }
      self.autoSave();
    };

    self.downClick = function (index) {
      if (index === self.paginated.length - 1) {
        self.paginated[index].DisplayOrder = 0;

        for (var i = 0; i < self.paginated.length; i++)
          if (self.paginated[i] != self.paginated[index])
            self.paginated[i].DisplayOrder++;
      }
      else {
        var dest, destDisplayOrder;

        dest = self.paginated[index + 1];
        destDisplayOrder = dest.DisplayOrder;

        dest.DisplayOrder = self.paginated[index].DisplayOrder;
        self.paginated[index].DisplayOrder = destDisplayOrder;
      }
      self.autoSave();
    };

    self.questionClick = function (surveyId, questionId) {
      if (!self.search.edit)
        $state.go('event.surveys.surveyQuestion', { id: surveyId, surveyQuestionId: questionId });

      return false;
    };

    self.edit = function (e) {
      self.search.edit = !self.search.edit
      e.target.value = self.search.edit;
      angular.element(e.target).triggerHandler('change', true);
    };

    self.activePredicate = function (active, edit) {
      if (edit === 'true')
        return true;
      else
        return active;
    };

    self.preview = function () {
      return self.save(false).then(function () {
        var previewData = {
          name: self.survey.Name,
          questions: self.survey.SurveyQuestions.filter(function(q) { return q.IsActive; }).map(function(q) {
            return angular.extend({}, q, {
              SurveyAnswers: q.SurveyAnswers.filter(function(a) { return a.IsActive; })
            });
          })
        };

        modalFactory.showModal({
          bodyTemplateUrl: 'views/shared/surveyPreviewModal.html',
          controller: 'SurveyPreviewModalCtrl',
          modalcss: 'small',
          inputs: {
            previewData: previewData,
            title: previewData.name
          }
        });
      });
    };

  };

  angular.module('exhibitorPortalApp')
    .constant('SAVE_STATUS', {
	    SAVING: 'saving',
	    SAVED: 'saved',
	    ERROR: 'error',
	    FADEOUT_SAVED: 'fadeout-saved',
	    FADEOUT_ERROR: 'fadeout-error'
	  })
    .controller('SurveyCtrl', SurveyCtrl);
})(angular, window);
